import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

import { TranslateModule } from '@ngx-translate/core';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { VcPatientListItem } from '../../../models/view-content.models/view-content.model';
import { CalAgePipe } from '../../../pipes/cal-age.pipe';
import { DayAgoPipe } from '../../../pipes/day-ago.pipe';

dayjs.extend(utc);

@Component({
  selector: 'app-home-patient-basic-info',
  templateUrl: './home-patient-basic-info.component.html',
  styleUrls: ['./home-patient-basic-info.component.scss'],
  standalone: true,
  imports: [
    CalAgePipe,
    CommonModule,
    DayAgoPipe,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatListModule,
    MatListModule,
    TranslateModule,
  ],
})
export class HomePatientBasicInfoComponent {
  @Input() patient: VcPatientListItem | undefined;
  @Input() disableDiagnosis = false;

  constructor() {}
}
